import { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'

import { Box, ChakraBaseProvider, Flex } from '@chakra-ui/react'
import claverTheme from '../../layout/components/layout/components/theme/claverTheme'

// Components
import DsrProspectHeader from './DsrProspectHeader'
import DsrGenericErrorModal from '../components//DsrGenericErrorModal'
import { redirectToNewPage } from '../../global/helpers/global-helpers'
import RenderProspectDsrContent from './RenderProspectDsrContent'
import DsrDynamicModal from '../messages/DsrDynamicModal'
import LaunchdeckBrandingLabel from '../../global/components/product-marketing/LaunchdeckBrandingLabel'
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal'


export default function DsrProspectDisplayPage({
  getProspectDsr,
  dsrInvalidRequestRedux,
  dsrPagesRedux,
  dsrTitleRedux,
  dsrStatusRedux,
  showDsrModalRedux,
  showDsrModalLoaderRedux,
  userActionRequiredRedux,
  dsrMainContact,
  signout,
  location,
  isProspectorOwner,
  isShrunkHeader,
  isMobileView
}) {

  const [localState, setLocalState] = useState({
    isDraft: "",
    renderContentType: '',
    currentDisplaySubpage: "",
    sectionIndex: 0,
    // DSR Metadata
    pDsrId: "",
    dsrCreatedAt: "",
    dsrPages: "",
    // DSR Team Members
    userProfile: "",
    // DSR Modal Management
    showDsrModal: false,
    showDsrModalLoader: false,
    userActionRequired: "",
    modalTransferPayload: ""
  })


  const { pDsrId } = useParams()
  const initRef = useRef(false);
  const { openLaunchdeckModal, closeLaunchdeckModal } = useLaunchdeckModal();

  const headerMenuHeight = isShrunkHeader ? '100px' : isProspectorOwner ? isMobileView ? '160px' : '140px' : isMobileView ? '170px' : '70px';

  useEffect(() => {
    if (!initRef.current && pDsrId) {
      document.title = 'Launchdeck Digital Sales Room'
      document.description = 'Create customised private digital sales rooms that let Sales & Purchasing teams agree on deals quickly'

      getProspectDsr({ pDsrId, status: 'active' })

      initRef.current = true
    }
  }, [pDsrId, getProspectDsr])


  useEffect(() => {
    if (((!pDsrId) || (dsrInvalidRequestRedux === true)) && initRef.current) {
      redirectToNewPage('/invalid') // TODO use react router
    }
  }, [pDsrId, dsrInvalidRequestRedux])


  useEffect(() => {
    if (signout) {
      if (signout?.results?.sign_out) {
        const excluded = ["/", "/home"]
        const redirectUrl = `${location.pathname}${location.search}`
        const isManualLogout = location.hash === '#logout'

        if (excluded.includes(redirectUrl) || isManualLogout) {
          redirectToNewPage('/login')
        } else {
          redirectToNewPage(`/login?redirect=${redirectUrl}`)
        }
      }
    }
  }, [signout])


  const handleDsrModalClose = () => {
    closeLaunchdeckModal()
  }

  const handleChangeUserActionRequired = (newUserActionRequired, modalTransferPayload) => {
    openLaunchdeckModal(newUserActionRequired)

    setLocalState((prevState) => ({
      ...prevState,
      modalTransferPayload,
    }))
  }


  return (
    <ChakraBaseProvider theme={claverTheme}>
      <Flex direction="column">
        <Flex direction="row" flexGrow="1">

          <Flex w="100%" direction="column" alignItems="center" bg="white">

            <>
              <Box width='100%' position='fixed' zIndex='2'>
                <DsrProspectHeader
                  pDsrId={pDsrId}
                  dsrTitle={dsrTitleRedux}
                  dsrMainContact={dsrMainContact}
                  pdsrPagesLocalState={dsrPagesRedux}
                  dsrStatus={dsrStatusRedux}
                  handleChangeUserActionRequired={handleChangeUserActionRequired}
                />
              </Box>

              <Flex w="100%" className="authentication-container"
                transition="padding 0.3s ease-in-out"
                justify="center" pt={headerMenuHeight} bg={'#F4F4F4'}>
                <RenderProspectDsrContent
                  pagesLocalState={dsrPagesRedux}
                  headerMenuHeight={headerMenuHeight}
                  isMobileView={isMobileView}
                />

                <DsrDynamicModal
                  pDsrId={pDsrId}
                  userActionRequired={userActionRequiredRedux}
                  showDsrModal={showDsrModalRedux}
                  showDsrModalLoader={showDsrModalLoaderRedux}
                  handleDsrModalClose={handleDsrModalClose}
                  modalTransferPayload={localState.modalTransferPayload}
                />

                <DsrGenericErrorModal
                  dsrId={pDsrId}
                  isProspectDsr={true}
                  handleCloseOtherModals={handleDsrModalClose}
                />

              </Flex>
            </>
          </Flex>
        </Flex>

        <LaunchdeckBrandingLabel />

      </Flex>
    </ChakraBaseProvider>
  )
}